var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgesPathwayCenterFaded = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 249.15 1734.13",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 20px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,258.85h-82.63c-40.46,0-73.26-32.8-73.26-73.26t0,0h0c0-40.46,32.79-73.26,73.25-73.27h80.08V10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,405.38h82.63c40.46,0,73.26-32.8,73.26-73.26h0c0-40.47-32.8-73.27-73.26-73.27h-82.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,405.38h-82.63c-40.46,0-73.26,32.8-73.26,73.26h0c0,40.46,32.79,73.26,73.25,73.27h82.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,698.44h82.63c40.46,0,73.26-32.81,73.26-73.27h0c0-40.46-32.8-73.26-73.26-73.26h-82.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,698.44h-82.63c-40.46,0-73.26,32.8-73.26,73.26h0c-.02,40.46,32.76,73.28,73.22,73.3h82.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,991.49h82.63c40.46,0,73.26-32.8,73.26-73.26h0c-.02-40.45-32.81-73.22-73.26-73.23h-82.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,991.49h-82.63c-40.46,0-73.26,32.8-73.26,73.26,0,0,0,0,0,.01h0c.01,40.45,32.81,73.24,73.26,73.24h82.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,1284.55h82.63c40.46,0,73.26-32.8,73.26-73.26h0c.01-40.47-32.78-73.28-73.24-73.29h-82.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,1284.55h-82.63c-40.46,0-73.26,32.8-73.26,73.26h0c0,40.46,32.79,73.26,73.25,73.27h82.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m165.89,1577.61h-82.63c-40.46,0-73.26,32.8-73.26,73.26h0c0,40.46,32.8,73.26,73.26,73.26h78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,1577.61h82.63c40.46,0,73.26-32.81,73.26-73.27h0c0-40.46-32.8-73.26-73.26-73.26h-82.63"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgesPathwayCenterFaded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgesPathwayCenter_Faded.9cb37ebc.svg";
export { ForwardRef as ReactComponent };